"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instagramFetchProfile = exports.instagramFetchProfileResultSchema = exports.instagramFetchProfileArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.instagramFetchProfileArgsSchema = zod_1.z.object({
    username: zod_1.z.string().describe('The Instagram username to fetch the profile for'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the result in.'),
});
exports.instagramFetchProfileResultSchema = zod_1.z.object({
    id: zod_1.z.string(),
    username: zod_1.z.string(),
    fullName: zod_1.z.string(),
    bio: zod_1.z.string(),
    followers: zod_1.z.number(),
    following: zod_1.z.number(),
    isPrivate: zod_1.z.boolean(),
    isVerified: zod_1.z.boolean(),
    profilePicUrl: zod_1.z.string().nullable(),
});
exports.instagramFetchProfile = (0, common_1.createEmitModeToolMetadata)({
    id: 'instagramFetchProfile',
    displayName: 'Instagram Fetch Profile',
    displayDescription: 'Fetch Instagram profile information for a given username.',
    category: 'search',
    color: common_1.BRAND_COLORS.INSTAGRAM,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.INSTAGRAM),
    icon: 'default',
    argsSchema: exports.instagramFetchProfileArgsSchema,
}, exports.instagramFetchProfileResultSchema);
